import { Menu, X } from "lucide-react";
import { useState, type PropsWithChildren } from "react";
import { Link, NavLink } from "react-router-dom";

export function Shell({ children }: PropsWithChildren) {
  const [open, setOpen] = useState(false);

  return (
    <div className="site-shell">
      <header className="site-header">
        <Link to="/" className="brand" aria-label="Entreventanas, inicio" onClick={() => setOpen(false)}>
          <img src="/brand-mark.svg" alt="" width="36" height="36" />
          <span>entreventanas</span>
        </Link>
        <button
          className="icon-button menu-button"
          type="button"
          aria-label={open ? "Cerrar menú" : "Abrir menú"}
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
        >
          {open ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
        </button>
        <nav className={open ? "primary-nav is-open" : "primary-nav"} aria-label="Navegación principal">
          <NavLink to="/catalogo" onClick={() => setOpen(false)}>Experiencias</NavLink>
          <NavLink to="/unir" onClick={() => setOpen(false)}>Unirme con código</NavLink>
          <NavLink to="/admin" onClick={() => setOpen(false)}>Editorial</NavLink>
        </nav>
      </header>
      <main>{children}</main>
      <footer className="site-footer">
        <div>
          <Link to="/" className="brand brand-footer" aria-label="Entreventanas, inicio">
            <img src="/brand-mark.svg" alt="" width="32" height="32" />
            <span>entreventanas</span>
          </Link>
          <p>Experiencias web para compartir. Sin instalación obligatoria.</p>
        </div>
        <div className="footer-links">
          <Link to="/catalogo">Catálogo</Link>
          <Link to="/privacidad">Privacidad</Link>
          <Link to="/admin">Panel editorial</Link>
        </div>
      </footer>
    </div>
  );
}
